const getCreateUpdateProjectReq = {
  projectID: 0,
  bidCollcetionMailingPeriod: 1,
  preparationMailingPeriod: 1,
  selectionMailingPeriod: 1,
  PreparationPhase: 'PreparationPhase',
  BidCollectionPhase: 'BidCollectionPhase',
  SelectionPhase: 'SelectionPhase',
};
export default getCreateUpdateProjectReq;
